import { ReactElement, useCallback, useContext } from 'react';
import Image from 'next/image';
import { Button, Heading, Link } from '@appsumo/dorado-react';
import clsx from 'clsx';

import { CartContext } from '~/contexts/cart';
import { useCart } from '~/lib/cart';
import { currencyWithCents } from '~/lib/format';
import { APPSUMO_PLUS_DEAL_ID } from '~/lib/util/constants';

import PlusBag from '~/public/plus-bag.png';

export default function PlusUpsellBody({
  hasPlusInCart = false,
  className = '',
}: {
  hasPlusInCart?: boolean;
  className?: string;
}): ReactElement {
  const { cart, user } = useContext(CartContext);
  const { lineItemAdd } = useCart(undefined, true);

  const onPlusClick = useCallback(
    () => lineItemAdd(APPSUMO_PLUS_DEAL_ID),
    [lineItemAdd],
  );

  if (user?.has_plus || !cart?.possible_plan_discount || hasPlusInCart) {
    return <></>;
  }

  return (
    <div
      className={clsx(
        "flex flex-col rounded border border-sundog bg-[url('~/public/plus-cart-banner-S.png')] bg-cover px-4 py-6 md:bg-[url('~/public/plus-cart-banner-M.png')] lg:col-start-1 lg:col-end-1 lg:flex-row lg:bg-[url('~/public/plus-cart-banner-L.png')]",
        className,
      )}
    >
      <div className="flex items-center lg:grow">
        <Image src={PlusBag} alt="plus-bag" height={56} />
        <div className="my-auto ml-2 grow">
          <Heading.H3 className="!text-sm font-semibold md:!text-base xl:!text-xl">
            Save&nbsp;
            <span className="text-ready-red">
              {currencyWithCents(cart.possible_plan_discount)}
            </span>
            &nbsp;on this order with AppSumo Plus!
          </Heading.H3>
          <p className="text-sm text-midnight">
            Join today for an extra 10% off all orders, VIP sales,{' '}
            <Link href="/plus" styled>
              and more
            </Link>
            !
          </p>
        </div>
      </div>
      <Button secondary onClick={onPlusClick} className="mt-4 lg:my-auto">
        Add for $99/year
      </Button>
    </div>
  );
}

export { PlusUpsellBody };
